import { required, helpers, sameAs } from 'vuelidate/lib/validators';
import {User} from "@/api/modules/userManagement/models/User";
import {StoreProxy} from "@/api/common/StoreProxy";
import {UserManagement} from "@/api/modules/userManagement/UserManagement";
import {AccountSearch} from "@/views/apps/Users/Common/AccountSearch";
import _ from 'lodash';


export default {
    name: "EditUser",
    props: {
        user: {
            type: Object,
            required: true,
            default: null
        }
    },
    data() {
        return {
            activeTab: 'user',
            username: '',
            account: '',
            firstName: '',
            lastName: '',
            email: '',
            isActive: false,
            formError: false,
            roles: [],
            availableRoles: [],
            isAccountLoading: false,
            checkedRoles: [],
        }
    },
    validations: {
        firstName: {
            required
        },
        lastName: {
            required
        },
        email: {
            required
        }
    },
    created() {

        if (this.user == null) {
            throw new Error('[e533854-ADM] Missing user prop. User is null!');
        }

        if (!(this.user instanceof User)) {
            throw new Error('[e167666-ADM] We expect a User object to this component.');
        }

        this._auth = StoreProxy.getAuth(this.$store);
        this._userManagement = new UserManagement(this._auth);
        this._accountSearch = new AccountSearch(this._auth);

        let vm = this;
        this._userManagement.getUserRoles(this.user.userId).then(roles => {
            vm.roles = roles;

            vm.roles.forEach(function (r) {
                vm.checkedRoles.push(r.name);
            });
        }).catch(e => {

            vm.roles = [];

            this.$notify.error({
                title: `User ${this.user.username} Roles`,
                message: 'Error when we attempted to retrieve the roles for this user.'
            });

        });

        this._userManagement.getRoles().then(roles => {
            vm.availableRoles = roles;
        }).catch(e => {

            vm.availableRoles = [];

            this.$notify.error({
                title: `Roles`,
                message: 'Error loading defined roles'
            });

        });
    },
    mounted() {

        this.account = this.user.account;
        this.username = this.user.username;
        this.firstName = this.user.firstName;
        this.lastName = this.user.lastName;
        this.email = this.user.emailAddress;
        this.isActive = this.user.isActive;

    },
    methods: {
        accountSearch(searchString, cb) {

            try {
                this.isAccountLoading = true;
                this._accountSearch.search(searchString).then(roles => {
                    cb(roles);
                    this.isAccountLoading = false
                }).catch(e => {
                    window.tracer.error(e);
                })
            } catch (e) {
                window.tracer.error(e);
            } finally {
                this.isAccountLoading = false;
            }

        },
        handleClick(tab, event) {

        },
        onSubmit() {

            this.$v.$touch();

            if (this.$v.$invalid) {
                this.formError = true;
                this.activeTab = 'user';
                return;
            }

            this.formError = false;
            let vm = this;

            this._updateUser().then(() => {
                vm._updateUserStatus().then(() => {
                    vm._updateRoles().then(() =>{
                        vm.$emit("onSubmitResult", true);
                    }).catch(e=> {
                        window.tracer.error("[e380255-ADM] Error updating roles ");
                        vm.$emit("onSubmitResult", false);
                    });
                }).catch(e => {
                    window.tracer.error("[e582897-ADM] Error updating user status (active/inactive)");
                    vm.$emit("onSubmitResult", false);
                })
            }).catch(e => {
                window.tracer.error("[e987912-ADM] Error updating user");
                vm.$emit("onSubmitResult", false);
            });

        },
        onCancel() {
            this.$emit("cancel")
        },
        _updateUser() {

            return new Promise((resolve, reject) => {
                try {
                    if (this._hasProfileChanged()) {

                        this.user.account = this.account;
                        this.user.firstName = this.firstName;
                        this.user.lastName = this.lastName;
                        this.user.emailAddress = this.email;

                        this._userManagement.updateUser(this.user).then(() => {
                            resolve();
                        }).catch(e => {
                            window.tracer.error("[e175504-ADM] Error updating user.")
                            if (e != null) {
                                window.tracer.error(e);
                            }

                            reject();
                        });
                    } else {
                        resolve();
                    }
                } catch (e) {
                    window.tracer.error("[e792417-ADM] Error updating user");

                    if (e != null) {
                        window.tracer.error(e);
                    }

                    reject(e);
                }
            });
        },
        /**
         * @param userId
         * @returns {Promise<()>}
         * @private
         */
        _updateRoles(){
            return new Promise((resolve, reject) => {
                try{

                    let vm = this;
                    let userId = vm.user.userId;
                    let success = true;
                    this.availableRoles.forEach(function(r) {

                        let exists = _.findIndex(vm.roles, function(o){
                            return o.name == r.name;
                        }) != -1

                        let isChecked = _.findIndex(vm.checkedRoles, function(o){
                           return o == r.name;
                        }) != -1;


                        if (!exists && isChecked) {
                            window.tracer.debug(`[d809366-ADM] Add ${r.name} role for user ${userId}`);
                            // does not exists in the retrieved roles, but exists in the checked roles, therefore add the role
                            vm._userManagement.addRole(userId, r.name).then(() => {
                                    window.tracer.debug(`[d881912-ADM] role ${r.name} added to user ${userId}`);
                                }
                            ).catch(e => {
                                success = false;
                                window.tracer.error(e);
                                reject(e);
                            })

                        }
                        else if (exists && !isChecked){
                            // does exists in the retrieved roles, but it has been unchecked, therefore remove the role.
                            window.tracer.debug(`[d290198-ADM] Remove ${r.name} role for user ${userId}`);
                            vm._userManagement.removeRole(userId, r.name).then(() => {
                                window.tracer.debug(`[d288691-ADM] role ${r.name} removed from user ${userId}`);
                                }
                            ).catch(e => {
                                success = false;
                                window.tracer.error(e);
                                reject(e);
                            })
                        }

                    });

                    if (success){
                        resolve();
                    }
                    else{
                        reject();
                    }

                }
                catch(e){

                    window.tracer.error(e);
                    window.tracer.error("[e147049-ADM] Failure adding/removing roles");
                    reject(e);

                }

            });
        },
        onSelectedAccount(item) {
            this.account = item;
        },
        _updateUserStatus() {

            return new Promise((resolve, reject) => {
                try{
                    if (this.user.isActive != this.isActive) {
                        if (this.isActive) {

                           this._userManagement.activateUser(this.user.userId).then(() =>{
                                resolve();
                            }).catch(e => {

                                window.tracer.error("[e228746-ADM] Error activating user");

                                if (e != null) {
                                    window.tracer.error(e);
                                }

                                reject();

                            });

                        } else {

                            this._userManagement.deactivateUser(this.user.userId).then(() =>{
                                resolve();
                            }).catch(e => {

                                window.tracer.error("[e950055-ADM] Error deactivating user");
                                if (e != null) {
                                    window.tracer.error(e);
                                }

                                reject();

                            });
                        }
                    }
                    else{
                        resolve();
                    }
                }
                catch(e){

                    window.tracer.error("[e622784-ADM] Error activating/deactivating user.")
                    if (e != null) {
                        window.tracer.error(e)
                    }
                    reject(e);
                }

            });

        },
        _hasProfileChanged() {

            let hasChanged = this.user.firstName != this.firstName;
            // noinspection JSBitwiseOperatorUsage
            hasChanged = hasChanged | this.user.lastName != this.lastName;
            // noinspection JSBitwiseOperatorUsage
            hasChanged = hasChanged | this.user.emailAddress != this.email;
            // noinspection JSBitwiseOperatorUsage
            hasChanged = hasChanged | this.user.account != this.account;

            return hasChanged;
        },
        companySelected(companyId) {
            this._$service.getCompanyBranches(companyId).then(branches => {
                    if (branches != null) {
                        this.branches = branches;
                    } else {
                        this.branches = [];
                    }
                }
            ).catch(error => {
                if (error != null) {
                    console.error(error);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Unable to load companies branches. Try again later.'
                });

                this.branches = [];
            });
        }

    },
}